import moment from "moment";

export const Types = {
  ADD_FILTRO_VALORES_DIARIOS:
    "filtrosValoresDiarios/ADD_FILTRO_VALORES_DIARIOS",
  SET_FILTRO: "filtrosValoresDiarios/SET_FILTRO",
  GET_VALUES: "filtrosValoresDiarios/GET_VALUES",
  GET_VALUES_SUCCESS: "filtrosValoresDiarios/GET_VALUES_SUCCESS",
  GET_PROPOSTAS_DIARIOS: "filtrosValoresDiarios/GET_PROPOSTAS_DIARIOS",
  GET_PROPOSTAS_DIARIOS_SUCCESS:
    "filtrosValoresDiarios/GET_PROPOSTAS_DIARIOS_SUCCESS"
};

const INITIAL_STATE = {
  openFiltro: true,
  date_type: "date-Data contrato",
  month: `${moment().format("MM")}-${moment().format("MMMM")}`,
  year: `${new Date().getFullYear()}-${new Date().getFullYear()}`,
  value: "value_released-Valor Liberado",
  users: [],
  stores: [],
  regions: [],
  data: [],
  propostas: [],
  columns: [],
  value_total: "",
  qtde: ""
};

export default function filtrosValoresDiarios(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.ADD_FILTRO_VALORES_DIARIOS:
      return {
        ...state,
        date_type: action.payload.data.date_type,
        month: action.payload.data.month,
        year: action.payload.data.year,
        value: action.payload.data.value,
        users: action.payload.data.users,
        stores: action.payload.data.stores,
        regions: action.payload.data.regions
      };
    case Types.SET_FILTRO:
      return {
        ...state,
        openFiltro: action.payload.data
      };
    case Types.GET_VALUES_SUCCESS:
      return {
        ...state,
        data: action.payload.data.data,
        qtde: action.payload.data.geral.qntd_sales,
        value_total: action.payload.data.geral.value_total
      };
    case Types.GET_PROPOSTAS_DIARIOS_SUCCESS:
      return {
        ...state,
        propostas: action.payload.propostas,
        columns: action.payload.columns
      };
    case Types.CLOSE:
      return { ...state, open: false };
    default:
      return state;
  }
}

export const Creators = {
  addFiltroValoresDiarios: data => ({
    type: Types.ADD_FILTRO_VALORES_DIARIOS,
    payload: { data }
  }),
  setFiltro: data => ({
    type: Types.SET_FILTRO,
    payload: { data }
  }),
  getValues: () => ({
    type: Types.GET_VALUES
  }),
  getValuesSuccess: data => ({
    type: Types.GET_VALUES_SUCCESS,
    payload: { data }
  }),
  getPropostasDiarios: date => ({
    type: Types.GET_PROPOSTAS_DIARIOS,
    payload: { date }
  }),
  getPropostasDiariosSuccess: (propostas, columns) => ({
    type: Types.GET_PROPOSTAS_DIARIOS_SUCCESS,
    payload: { propostas, columns }
  })
};



// WEBPACK FOOTER //
// ./src/store/ducks/filtrosValoresDiarios.js